import { Box } from '@mui/material';
import React from 'react';
import CusSwitch from './CusSwitch';

/**
 * ReverseSwitch component
 * @param {React.ComponentProps<typeof CusSwitch>} props - Все пропсы CusSwitch
 * @returns {JSX.Element}
 */
export default function ReverseSwitch({ ...props }) {
  return (
    <Box width={'fit-content'}>
      <CusSwitch {...props} reverse />
    </Box>
  );
}
